import PromotionListingPage from '../promotion-list';

interface IBundlePromo {}

const BundlePromo: React.FunctionComponent<IBundlePromo> = props => {
  return <PromotionListingPage promo={'BUNDLE_DISC'} promoName="Bundle Discount" />;
};

export default BundlePromo;
